import { useEffect, useState } from "react";
import { getLocalTours } from "../services/API";
import CardLayout3 from "./CardLayout3";
import type { cards } from "../Types";


const LocalToursContainer: React.FC<cards>= ({title}) => {
    
    const [localtours, setLocalTours] = useState([]);

    const initData = async () => {
        const data = await getLocalTours()
        if (data) {
            setLocalTours(data)
        }
    }

    useEffect(() => {
        initData()
    }
    ,[])


  return (
    <>
    { localtours ? 
        <section className="app-section container-fluid pt-0">
                <div className="container pb-5 pb-md-5 pb-lg-2">

                    <div className="row pb-4 pb-md-5 mt-md-4 mt-lg-0">
                        <h2 className="fw-bold fs-4 fs-md-4 col">{title}</h2>
                    </div>
                    
                    <div className="row row-cols-1 row-cols-md-2 g-4">
                        {localtours.slice(0, 6).map((localtour: any) => {
                            return (
                                <div className="col" key={localtour.entryId ?? localtour.DDLink}>
                                    <CardLayout3
                                        image={localtour.DDImage}
                                        title={localtour.DDTourName}
                                        duration={localtour.DDDuration}
                                        category={localtour.DDDurationCategory}
                                        introduction={localtour.Itinerary_txt}
                                        href={localtour.DDLink}
                                    />
                                </div>
                            )
                        })}
                    </div>
                    
                </div>
        </section>   
    : " "}
    </>
  )
}

export default LocalToursContainer